import {Injectable,ApplicationRef, NgZone} from '@angular/core';

@Injectable()
export class IeHackService {

  constructor(
    private _appRef: ApplicationRef,
    private _zone: NgZone) {}

  private isIe() {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
      return true;
    return false;
  }

  onComponentLoadInIe() {
    if (this.isIe()) {
      this._zone.run(() => setTimeout(() => this._appRef.tick(), 5));
    }
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/utils/msieComponentLoad.ts